import { BranchData } from "src/components/BranchSelector";

export interface CountByStateResult {
    state: RaceState;
    quantity: number;
}
export interface VisitCountByStateResult {
    state: VisitState;
    quantity: number;
}

export enum VisitState {
    CREATED = "CREATED",
    ASSIGNED = "ASSIGNED",
    IN_PROGRESS = "IN_PROGRESS",
    DELIVERED = "DELIVERED",
    CANCELLED = "CANCELLED",
}
export enum RaceState {
    CREATED = "CREATED",
    ASSIGNED = "ASSIGNED",
    IN_PROGRESS = "IN_PROGRESS",
    DELIVERED = "DELIVERED",
    CANCELLED = "CANCELLED",
}

export type RaceType = "DELIVERY" | "SEND_PACKET" | "TAXI" | "OTHER";
export type VisitType = "VISIT";

export interface AddVisitDTO {
    type: string;

    observation?: string;
    amount?: number;

    dueDate?: number;

    driver: number | null;

    clientName: string;
    clientDocument: string;
    clientPhone?: string;
    clientEmail?: string;

    destiny: Location[];

    branch?: number | undefined;
}
export interface AddRaceDTO {
    type: string;

    observation?: string;
    amount?: number;

    dueDate?: number;

    driver: number | null;

    clientId: number;
    clientName: string;
    clientDocument: string;
    clientPhone?: string;
    clientEmail?: string;

    origin: Location;
    destiny: Location;

    branch?: number | undefined;
}

export interface Opportunity {
    id: number;

    owner: Client;
    driver?: Driver;
    creator: User;

    type: RaceType;
    observation: string;

    startDate: number;
    dueDate?: number;
    endDate?: number;

    assignedDate?: number;
    pickDate?: number;

    capital?: number;

    route: Route;

    state: RaceState;

    referenceId: number;
}
export interface Race {
    id: number;

    branch: BranchData;
    branchDestiny?: BranchData;
    owner: Client;
    driver: Driver;
    creator: User;

    type: RaceType;
    observation: string;

    startDate: number;
    dueDate?: number;
    endDate?: number;

    assignedDate?: number;
    pickDate?: number;

    capital?: number;

    route: Route;

    state: RaceState;

    referenceId: number;

    tipoComprobante?: string;
    nroComprobante?: string;

    files?: any;
    motivoNoFirma?: string;
    recepcionCi?: string;
    recepcionAclaracion?: string;
    recepcionFirma?: string;
    observationEntrega?: string;
    estadoDeEntrega?: boolean


}

export interface Route {
    origin: Location;
    destiny: Location;
    mapLine: string;
    length: number;
    price: number;
}

export interface SimpleLocation {
    lat: number;
    lng: number;
}

export interface Location extends SimpleLocation {
    street1: string;
    street2?: string;
    observation?: string;
    number?: number;
    id?: number;
}

export interface User {
    id: number;
    name: string;
    email: string;
    state: "ACTIVE" | "INACTIVE";
}

export interface Client {
    id: string;
    user: User;
    document: string;
    phone?: string;
    observation?: string;
}

export interface Driver {
    id: number;
    user: User;
    region: string;
    registryNumber: string;
    registryDate: number | string;
    vehicle?: Vehicle;
    vehicles: Vehicle[];
    branch: BranchData;
    notifyLocation: boolean;
    notifyLogout: boolean;
    recordLocation: boolean;
    outsourced: boolean;
    fixedPayment: number;
    paymentPerKm: number;
    document: string;
    markAttendance?: boolean;
    manager?: boolean;
    referenceId?: number;
}

export type VehicleType = "CAR" | "MOTORCICLE" | "TRUCK";

export interface Vehicle {
    brand: string;
    year: string;
    model: string;
    image: string;
    type: VehicleType;
    capacidadVolumetrica: number;
    fixedPayment?: number;
    paymentPerKm?: number;
}

export interface DriverStateDTO {
    id: number;
    name: string;

    raceId: number;
    raceName: string;
    raceState: RaceState;
    state: RaceState;
    raceType: RaceType;

    lat: number;
    lng: number;
    locationDate: number;

    lastRaceId: number;
    lastRaceName: string;

    lastAction: number;

    raceCount: number;
}

export interface Company {
    id: number;
    name: string;
    photo?: string;
    adminId: number;
    pingUrl?: string;
    referenceId?: string;
    dbIP?: string;
    dbPort?: string;
    dbUser?: string;
    dbName?: string;
    dbPass?: string;
    dbType?: string;
}

export interface DriverHistory {
    lat: number;
    lng: number;
    id: number;
    locationDateTime: number;
}
export interface VisitReason {
    id?: number;
    description: string;
}
export interface DriverVisitHistory {
    id: number;
    lat: number;
    lng: number;
    visitDate: string;
    visitReason: VisitReason;
    obs: string;
    client: Client;
    driver: Driver;
}

export enum TypeNotification {
    INDIVIDUAL = 'INDIVIDUAL',
    GROUP = 'GRUPO',
    AUTOMATIC = 'AUTOMATICO',
    OTHER = 'OTROS'
}

export interface NotificationHistory {
    message: string,
    notificacionDate: string,
    driver: Driver,
    type: TypeNotification
}

export interface Visit {
    id: number;
    branch: number | undefined;
    clientId: number;
    driver?: Driver;

    lat: number;
    lng: number;
    obs: string;

    visitDate: number;
    visitDateTime: number | undefined;

    visitReason: VisitReason;
    visited: boolean | undefined;
}

// Route Planning Models
export interface Parada {
    secuenciaParada: number;
    tipoParada: string;
    nodoId: number;
    nombreSucursal: string;
    branchId?: number | null; // ID de sucursal registrada en el sistema
    coordenadas: number[]; // [longitude, latitude]
    coordenadas_lat_lng: number[]; // [latitude, longitude]
    horaLlegada: string;
    horaSalida: string | null;
    ventanaTiempo: string | null;
    cajasAEntregar: number;
}

export interface Ruta {
    vehiculoId: number;
    matricula?: string; // Matrícula del vehículo del WS
    driverId?: number; // ID del driver mapeado
    tiempoTotalRutaHhmm: string;
    kilometrajeTotalRutaKm: number;
    cargaTotalRutaCajas: number;
    paradas: Parada[];
}

export interface Planning {
    id?: string;
    totalKm: number;
    totalVehicles: number;
    totalBoxes: number;
    routings: Routing[];
    totalDays?: number;
    planningDate?: string;
    planningEndDate?: string;

}

export interface Routing {
    planningId?: string;
    driverId: number;
    driver?: Driver;
    raceSchedules: RaceSchedule[];
}

export interface RaceSchedule {
    visitDateTimeSchedule: string
    selectedDriver: number,
    driver?: Driver,
    limit: number
    races: Race[]
    raceDetails?: Race[]
    order: number
    routingId?: string
}

export type RutasData = Ruta[];


// WEBPACK FOOTER //
// ./src/api/model.ts